import {
  SIGNIN_SMS_VERIFICATION_FORM_SHOW,
  SIGNIN_SMS_VERIFICATION_FORM_HIDE,
  FETCH_SMS_REJECTED,
  SIGNIN_SMS_VERIFICATION_REJECTED
} from "../constants/signinWithSms";
import { signIn } from "./signin";
import { request } from "../axios/request";

export const showModalAction = ({ data }) => ({
  type: SIGNIN_SMS_VERIFICATION_FORM_SHOW,
  data
});

export const hideModalAction = () => ({
  type: SIGNIN_SMS_VERIFICATION_FORM_HIDE
});

export const smsRejected = ({ response: { data } }) => ({
  type: FETCH_SMS_REJECTED,
  error: data
});

const smsVerificationRejected = ({ response: { data } }) => ({
  type: SIGNIN_SMS_VERIFICATION_REJECTED,
  data
});

export const completeDispatcher = response => dispatch => {
  dispatch(signIn(response.data.redirect_url));
  dispatch(hideModalAction());
};

export const fetchSms = (url, data = {}) => dispatch => {
  request({
    method: "POST",
    url,
    data
  })
    .then(response => {
      if (response.status === 202) {
        dispatch(showModalAction(response));
      } else if (response.status === 200) {
        dispatch(completeDispatcher(response));
      }
    })
    .catch(error => {
      if (error.request.responseURL.includes("verify=true")) {
        dispatch(smsVerificationRejected(error));
      } else {
        dispatch(smsRejected(error));
      }
    });
};



// WEBPACK FOOTER //
// ./src/actions/signinWithSms.js